import { useArticleInfoQuery } from "@api/articleInfo/useArticleInfo";
import { getPressIdFromURL } from "@utils/getStateFromURL";

export const useCheckClassificationPreclinical = () => {
  const draftArticleId = getPressIdFromURL();
  const { data: articleInfo } = useArticleInfoQuery(Number(draftArticleId));

  const classificationCode = articleInfo?.classificationManual;
  const isPreclinical = classificationCode === "C005";

  return {
    isPreclinical,
  };
};
